
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/peer-tutoring",
      function () {
        return require("private-next-pages/about/peer-tutoring.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/peer-tutoring"])
      });
    }
  